"use client";

import urljoin from "url-join";

import type { Teaser } from "@jti/product-details";
import { TeaserCarousel } from "@jti/product-details";

import { rewriteUrls } from "@/app/_internal/rewriteUrls/rewriteUrls";
import { SHOP_PAGE_SLUG } from "@/app/[locale]/(default)/shop/constants";
import { useLocale } from "@/context/LocaleContext";

import type { ProductTeaserCarouselProps } from "./ProductTeaserCarousel.inputs";

export function ProductTeaserCarousel({
  title = "",
  items,
  customBadgeDark = false,
  discoverLabel = "",
  discoverPageLink = "",
  hideBuyCta = false,
  hideCustomBadge = false,
  hideDescription = false,
  hideDiscountBadge = false,
  hideDiscoverButton = false,
  hidePrice = false,
  hidePriceInformation = false,
  hideRightBadge = false,
  hideStrikethroughPrice = false,
  redirectHref = "",
  redirectLabel = "",
  rightBadgeDark = false,
  tryNowLabel = "",
}: ProductTeaserCarouselProps) {
  const { currentLocale } = useLocale();

  if (!items || items?.length === 0) return null;

  return (
    <TeaserCarousel
      title={title}
      carouselRedirectHref={redirectHref}
      carouselRedirectLabel={redirectLabel}
      teasers={items?.map((item): Teaser => {
        return {
          hideBuyCTA: hideBuyCta,
          hidePrice,
          customBadgeDark,
          freeTrialProduct: false,
          hideCustomBadge,
          hideDescription,
          hideDiscountBadge,
          hideDiscoverButton,
          hidePriceInformation,
          hideRightBadge,
          hideStrikethroughPrice,
          productPageLink:
            item?.urlKey && item?.category
              ? urljoin(
                  "/",
                  currentLocale,
                  rewriteUrls(urljoin("/", SHOP_PAGE_SLUG, item.category, item.urlKey), currentLocale)
                )
              : "",
          rightBadgeDark,
          discoverLabel,
          discoverPageLink,
          tryNowLabel,
          sticksData: "",
          customBadge: "",
          customBadgeIcon: "",
          priceInformation: "",
          rightBadge: "",
          priceInformationIcon: "",
          rightBadgeIcon: "",
          productData: {
            bundle: item?.type === "BundleProduct",
            colorVariantsStringified: item?.colorVariantsStringified ?? "",
            imageSrc: item?.imageSrc ?? "",
            url: item?.urlKey ?? "",
            name: item?.name ?? "",
            sku: item?.sku ?? "",
            imageAlt: item?.imageLabel ?? "",
            shortDescription: item?.shortDescription ?? "",
          },
        };
      })}
    />
  );
}
